import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactRedux from 'react-redux';
import store from 'store';
import BaseModal from 'Modals/BaseModal';
import connectModal from 'Modals/enhancers/ConnectModal';
import ModalTypeEnum from 'Modals/ModalConstants';

const UpdateSubscriptionProgressModalWithRedux = connectModal(BaseModal);

export default class UpdateSubscriptionProgressModal extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <ReactRedux.Provider store={store}>
        <UpdateSubscriptionProgressModal {...props} />
      </ReactRedux.Provider>,
      document.getElementById(id),
    );
  }

  render() {
    return (
      <UpdateSubscriptionProgressModalWithRedux
        modalType={ModalTypeEnum.UPDATE_SUBSCRIPTION_PROGRESS_READY}
        headerText="Updating Subscription..."
        bodyContent={(
          <React.Fragment>
            <p>Please wait, this could take up to 15 seconds.</p>
            <p><b>Do not refresh</b> your browser</p>
          </React.Fragment>
        )}
        footerContent={(
          <img alt="Loading" src="//cdn.smartresumewizard.com/images/icons/loading_circle.gif" />
        )}
        ariaLabel="Updating Subscription"
      />
    );
  }
}




// WEBPACK FOOTER //
// ./src-react/Modals/UpdateSubscriptionProgressModal/index.jsx